export default __webpack_public_path__ + "static/media/map_graph_gif_grey.e3c4341d.gif";